import React, { Component } from "react";
import Paper from "@material-ui/core/Paper";
import MenuItem from "@material-ui/core/MenuItem";
import { connect } from "react-redux";
import CustomizedSelect from "../transactions/customizedSelect";
import DateFnsUtils from "@date-io/date-fns";
import { Input } from "../../forms/input";
import Signbutton from "../../forms/button";
import CustomizedDialogs from "../../home/customModal";
import { MBRStatusDialog } from "../../home/customModal";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import {
  GET_FUNDS_LIST,
  GET_FUNDS_LIST_SUCCESS,
  GET_FUNDS_LIST_FAILED,
  ALL,
} from "../../../store/types";
import {
  getInvestorDetails,
  getNewPurchaseFundList,
} from "../../../store/actions";
import {
  getMailbackList,
  GetDistMailbackRequest,
} from "../../../store/actions/mailback";
import IntegrationReactSelect from "../../forms/autoCompleteInput";
import { BajajFund } from "../nav";
import CustomLoader from "../../forms/Loader";
export const MAILBACK_URL = `/mailBackRequest`;
class MailBack extends Component {
  constructor(props) {
    super(props);
    const { state } = this.props.location;
    this.state = {
      fund: { value: "" },
      reports: [],
      display: false,
      showPassword: false,
      status: {
        value: false,
      },
      report:
        !!state && !!state.value
          ? {
              value: {
                label: state.value.KDM_Repdesc,
                value: state.value.KDM_Repcode,
              },
            }
          : { value: "" },
      reportType: { value: "" },
      fromDate: { value: null, error: false },
      toDate: { value: null, error: false },
      password: { value: "" },
      open: false,
      refrenceNumber: { value: "" },
    };
  }

  async componentDidMount() {
    const params = {
      customfund: "189",
    };
    const response = await this.props.getMailbackList(params);
    if (response) {
      this.setState({
        reports: response.DtData,
      });
    }
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }
  handleChangeReports = (value) => {
    this.setState({
      report: { value },
    });
  };
  handleChangeReportTypes = (event) => {
    this.setState({
      reportType: { value: event.target.value },
    });
  };
  handleChangeFunds = (value) => {
    this.setState({
      fund: { value },
    });
  };
  handleChangePassword = (event) => {
    this.setState({
      password: { value: event.target.value },
    });
  };
  onDateChange = (label, event) => {
    if (label === "toDate" && !!this.state.fromDate.value && !!event) {
      const reformtStDt = this.state.fromDate.value.toLocaleDateString(
        "en-US",
        {
          month: "2-digit",
          year: "numeric",
          day: "2-digit",
        }
      );

      const changeEndDt = event.toLocaleDateString("en-US", {
        month: "2-digit",
        year: "numeric",
        day: "2-digit",
      });

      const d2 = new Date(reformtStDt).setHours(12, 0, 0, 0);
      const d3 = new Date(changeEndDt).setHours(12, 0, 0, 0);
      if (d2 > d3) {
        this.setState({
          [label]: {
            value: null,
            error: true,
            errorMessage: "Start Date should be earlier than End Date",
          },
        });
      } else {
        this.setState({
          [label]: { value: event, errorMessage: "", error: false },
        });
      }
    } else if (label === "fromDate") {
      this.setState({
        [label]: { value: event },
        toDate: { value: null, error: "", errorMessage: "" },
      });
    }

    // this.setState({ [label]: { value: event } });
  };

  submit = async () => {
    let toDateValue;
    let fromDateValue;

    if (this.state.fromDate.value) {
      fromDateValue = this.state.fromDate.value.toLocaleDateString("en-US", {
        month: "2-digit",
        year: "numeric",
        day: "2-digit",
      });
    }
    if (this.state.toDate.value) {
      toDateValue = this.state.toDate.value.toLocaleDateString("en-US", {
        month: "2-digit",
        year: "numeric",
        day: "2-digit",
      });
    }
    const {
      funds,
      reports,
      // fromDate,
      status,
      // toDate,
      fund,
      display,
      open,
      showPassword,
      refrenceNumber,
      ...others
    } = this.state;
    if(this.state.fromDate.value===this.state.toDate.value)
    {
      this.setState({
        toDate: {
          value: null,
          error: true,
          errorMessage: "start date and end date cannot be same",
        },
      });
      return;
    }

    const keys = Object.keys(others);
    const d2 = new Date(this.state.fromDate.value).setHours(12, 0, 0, 0);
    const d3 = new Date(this.state.toDate.value).setHours(12, 0, 0, 0);
    if(d2===d3)
    {
      this.setState({
        toDate: {
          value: null,
          error: true,
          errorMessage: "start date and end date cannot be same",
        },
      });
      return;
    }

    const findError = keys.every((key) => !!others[key].value);

    if (!findError) {
      keys.forEach((key) => {
        !others[key].value &&
          this.setState({
            [key]: {
              ...others[key],
              isError: true,
              errorMessage: `${
                key === "report"
                  ? "Report"
                  : key === "reportType"
                  ? "Report Type"
                  : key === "fromDate"
                  ? "Start date"
                  : key === "toDate"
                  ? "End date"
                  : key === "password"
                  ? "Password"
                  : key === "fromDate"
                  ? "Start date"
                  : key === "toDate"
                  ? "End date"
                  : ""
              } is mandatory*`,
            },
          });
      });
      const firstErroredKey = keys.find((key) => !others[key].value);
      switch (firstErroredKey) {
        // case "fund": {
        //   this.fundField.focus();
        //   break;
        // }
        case "report": {
          this.reportField.focus();
          break;
        }
        case "reportType": {
          this.reportTypeField.focus();
          break;
        }
        // case "fromDate": {
        //   this.fromDateField.focus();
        //   break;
        // }
        // case "toDate": {
        //   this.toDateField.focus();
        //   break;
        // }
      }
    } else if (
      others.password.value === "" ||
      !/^(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/.test(
        others.password.value
      )
    ) {
      if (
        !/^(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/.test(
          others.password.value
        )
      ) {
        // this.passwordField.focus();
        this.setState({
          password: {
            ...others["password"],
            isError: true,
            errorMessage: `Password should be atleast 8 characters in length and should contain at least 1 Upper Case alphabet(A-Z).1 Special Character and 1 Numeric Value (0-9)`,
          },
        });
        return;
      } else {
        this.passwordField.focus();
        this.setState({
          password: {
            ...others["password"],
            isError: true,
            errorMessage: `Password is mandatory`,
          },
        });
        return;
      }
    } else if (!this.state.fromDate.value) {
      this.setState({
        fromDate: {
          value: null,
          error: true,
          errorMessage: "From date is mandatory",
        },
      });
      return;
    } else if (!this.state.toDate.value) {
      this.setState({
        toDate: {
          value: null,
          error: true,
          errorMessage: "To date is mandatory",
        },
      });
      return;
    } else if (d2 > d3) {
      this.setState({
        toDate: {
          value: null,
          error: true,
          errorMessage: "From date should be earlier than To date",
        },
      });
    } else {
      this.setState({
        display: true,
      });
      const params = {
        Userid: this.props.userId,
        ReportNumber: this.state.report.value.value,
        ZipPwd: this.state.password.value,
        Fund: "189",
        customfund: "189",
        toDate: toDateValue,
        fromDate: fromDateValue,
        ReqBy: ALL,
        Agent: this.props.token,
        reportType: this.state.reportType.value === "Excel" ? "Excel" : "DBF",
      };
      const response = await this.props.GetDistMailbackRequest(params);
      if (response) {
        this.setState({
          display: false,
          open: true,
          refrenceNumber: { value: response.DtData[0].Refno },
        });
      }
    }
  };

  closeModal = () => {
    this.setState({
      open: false,
      fund: { value: "" },
      report: { value: "" },
      reportType: { value: "" },
      fromDate: { value: null, error: false },
      toDate: { value: null, error: false },
      password: { value: "" },
      refrenceNumber: { value: "" },
    });
  };
  showError = (label) => (event) => {
    const {
      [label]: { value },
    } = this.state;

    if (label === "") {
      this.setState({
        [label]: {
          value,
          isError: this.state.selfPassword.value === "" ? true : !value,
          errorMessage:
            this.state.selfPassword.value === ""
              ? `Self-password is mandatory`
              : "",
        },
      });
    } else {
      this.setState({
        [label]: {
          value,
          isError: !value,
        },
      });
    }
  };
  close() {
    this.setState({
      status: {
        value: false,
      },
    });
  }

  gotoblur = () => {
    if (
      this.state.password.value === "" ||
      !/^(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/.test(
        this.state.password.value
      )
    ) {
      if (
        !/^(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/.test(
          this.state.password.value
        )
      ) {
        this.setState({
          password: {
            isError: true,
            errorMessage: `Password should be atleast 8 characters in length and should contain at least 1 Upper Case alphabet(A-Z).1 Special Character and 1 Numeric Value (0-9)`,
          },
        });
        return;
      } else {
        this.passwordField.focus();
        this.setState({
          password: {
            value: "",
            isError: true,
            errorMessage: `Password is mandatory`,
          },
        });
        return;
      }
    }
  };
  render() {
    const { fundsList, location } = this.props;
    const { fund, reports, report, reportType, password, display } = this.state;
    const { state } = location;
    return (
      <div className="container-margin">
        <div className="investor-title">Mail back Request for Self-Reports</div>
        <CustomLoader display={!!display} />
        <Paper
          className="digital-form-container ekyc-paper"
          style={{
            boxShadow: "0px 0px 2px 0px lightgray",
            marginLeft: 0,
            marginRight: 0,
            marginTop: 20,
          }}
        >
          <div className="digital-form-Right-div">
            <div className="transaction-details-responsive">
              <div className="appbar-div dual-margin">
                <div className="input-name">AMC</div>
                <BajajFund />
              </div>
              <div className="appbar-div dual-margin ">
                <div className="input-name">Select Report</div>
                <IntegrationReactSelect
                  suggestions={reports.map((item) => ({
                    label: item.KDM_Repdesc,
                    value: item.KDM_Repcode,
                  }))}
                  value={report.value}
                  placeholder="Select Report"
                  errorMessage={report.errorMessage}
                  maxDate={new Date()}
                  disabled={!!state && !!state.value}
                  inputRef={(ele) => (this.reportField = ele)}
                  isError={report.isError}
                  isShowError={report.isError}
                  handleChange={this.handleChangeReports}
                />
              </div>

              <div className="appbar-div dual-margin">
                <div className="input-name">Report Type</div>
                <CustomizedSelect
                  handleChange={this.handleChangeReportTypes}
                  nolabel={true}
                  value={reportType.value}
                  inputRef={(ele) => (this.reportTypeField = ele)}
                  isError={reportType.isError}
                  errorMessage={reportType.errorMessage}
                  isShowError={reportType.isError}
                  placeholder="Select Report Type"
                >
                  <MenuItem value="Excel" key="Excel">
                    Excel
                  </MenuItem>
                  <MenuItem value="DBF" key="DBF">
                    DBF
                  </MenuItem>
                </CustomizedSelect>
              </div>

              <div className="appbar-div dual-margin">
                <Input
                  name="Password To Open"
                  onChange={this.handleChangePassword}
                  type={!!this.state.showPassword ? "text" : "password"}
                  image={"/images/locked.svg"}
                  image2={
                    !!this.state.showPassword
                      ? "/images/Bajaj_eye.svg"
                      : "/images/Bajaj_eye_hide.svg"
                  }
                  onClick={() => {
                    this.setState({
                      showPassword: !this.state.showPassword,
                    });
                  }}
                  value={password.value}
                  isShowError={password.isError}
                  isShowPasswordError={password.isPasswordError}
                  inputRef={(ele) => (this.passwordField = ele)}
                  errorMessage={password.errorMessage}
                  onBlur={this.gotoblur}
                />
              </div>

              <div className="appbar-div dual-margin date-pickers">
                <div className="input-name">From Date</div>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    InputProps={{ readOnly: true }}
                    required={true}
                    className="selects"
                    style={{
                      margin: "0px 0px 20px 0px",
                      border: !!this.state.fromDate.error
                        ? "1px solid red"
                        : "none",
                      borderTop: !!this.state.fromDate.error
                        ? "2px solid red"
                        : "none",
                      borderRadius: !!this.state.fromDate.error ? 7 : 0,
                    }}
                    onChange={(e) => this.onDateChange("fromDate", e)}
                    // openTo={true}
                    disableFuture={true}
                    format="dd/MM/yyyy"
                    maxDate={new Date()}
                    minDate={new Date(2000, 0, 1)}
                    // animateYearScrolling={true}
                    id="mui-pickers-date"
                    value={this.state.fromDate.value}
                  />
                  {!!this.state.fromDate.errorMessage ? (
                    <div
                      style={{ color: "red", fontFamily: "Rubik-Italic" }}
                    >
                      {this.state.fromDate.errorMessage}
                    </div>
                  ) : (
                    ""
                  )}
                </MuiPickersUtilsProvider>
              </div>
              <div className="appbar-div dual-margin">
                <div className="input-name">To Date</div>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    InputProps={{ readOnly: true }}
                    required={true}
                    className="selects"
                    style={{
                      // margin: "0px 0px 20px 0px",
                      border: !!this.state.toDate.error
                        ? "1px solid red"
                        : "none",
                      borderTop: !!this.state.toDate.error
                        ? "2px solid red"
                        : "none",
                      borderRadius: !!this.state.toDate.error ? "7px" : 0,
                    }}
                    onChange={(e) => this.onDateChange("toDate", e)}
                    // openTo={true}
                    disabled={!this.state.fromDate.value ? true : false}
                    disableFuture={true}
                    format="dd/MM/yyyy"
                    errorMessage={this.state.toDate.errorMessage}
                    maxDate={new Date()}
                    minDate={new Date(2000, 0, 1)} // animateYearScrolling={true}
                    id="mui-pickers-date"
                    value={this.state.toDate.value}
                  />
                  {!!this.state.toDate.errorMessage ? (
                    <div
                      style={{ color: "red", fontFamily: "Rubik-Italic" }}
                    >
                      {this.state.toDate.errorMessage}
                    </div>
                  ) : (
                    ""
                  )}
                </MuiPickersUtilsProvider>
              </div>
              <CustomizedDialogs
                open={this.state.open}
                refNo={this.state.refrenceNumber.value}
                closeModal={this.closeModal}
                myself={true}
                componentName="MailBacKRequest"
              />
            </div>
            <div className="digital-form-button-next-div">
              <Signbutton buttontitle="Submit" onClick={this.submit} width={"50%"}  customStyle={{display:"flex",justifyContent:"center"}}/>
            </div>
          </div>
        </Paper>
      </div>
    );
  }
}

export default connect(
  ({ authReducer, transactions }) => {
    const { investorData, userId, token } = authReducer;
    const { fundsList } = transactions;
    return { investorData, userId, token, fundsList };
  },
  {
    getNewPurchaseFundList,
    getInvestorDetails,
    getMailbackList,
    GetDistMailbackRequest,
  }
)(MailBack);
export const getCurrentFinancialYearDates = () => {
  const today = new Date();
  const currentYear = today.getFullYear();
  const startDate = new Date(currentYear, 3, 1);
  const endDate = today;
  return { startDate, endDate };
};

export const getPreviousFinancialYearDates = () => {
  const today = new Date();
  const currentYear = today.getFullYear();
  const startDate = new Date(currentYear - 1, 3, 1); 
  const endDate = new Date(currentYear, 2, 31);
  return { startDate, endDate };
};